import { render, staticRenderFns } from "./dashExamen.vue?vue&type=template&id=27647540&"
import script from "./dashExamen.vue?vue&type=script&lang=js&"
export * from "./dashExamen.vue?vue&type=script&lang=js&"
import style0 from "./dashExamen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports